import { Routes, Route, useOutletContext } from "react-router-dom";
import { Calendrier } from "../Pages/Private/Manifestation/Calendrier";
import { ListContacts } from "../Pages/Private/Manifestation/Contact/ListContacts";
import { FicheContact } from "../Pages/Private/Manifestation/Contact/FicheContact";
import { ManifestationsList } from "../Pages/Private/Manifestation/Manifestation/Manifestations";
import { FicheManifestation } from "../Pages/Private/Manifestation/Manifestation/FicheManifestation";
import { FicheActivity } from "../Pages/Private/Manifestation/Manifestation/FicheActivity";
import { EspaceList } from "../Pages/Private/Manifestation/Espace/EspaceList";
import { InventaireList } from "../Pages/Private/Manifestation/Inventaire/InventaireList";

EspaceList;
export const ActivitiesRouter = () => {
    const [user, setUser] = useOutletContext();

    return (
        <Routes>
            <Route path="/projets" element={<ManifestationsList />} />
            <Route path="/espaces" element={<EspaceList />} />
            <Route path="/inventaires" element={<InventaireList />} />
            <Route path="/projets/fiche/:id" element={<FicheManifestation />} />
            <Route path="/projets/activite/:id" element={<FicheActivity />} />
            <Route path="/calendrier" element={<Calendrier />} />
            <Route path="/contacts" element={<ListContacts />} />{" "}
            <Route path="/contact/:id" element={<FicheContact />} />{" "}
            <Route path="/planning" element={<Calendrier />} />
        </Routes>
    );
};
